import React, {useState} from 'react';
import IconButton from '@mui/material/IconButton';
import {FaUserFriends} from 'react-icons/fa';
import {MdGroup, MdClose} from 'react-icons/md'; // Import MdClose
import './ChatComponentHeader.css';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import {Tooltip} from "@mui/material";

const ChatComponentHeader = ({groupUsers, users, caseNumber, groupId, handleEditChatGroup}) => {
    const [open, setOpen] = useState(false);
    const uniqueGroupUsers = Array.from(new Set(groupUsers));
    const displayLimit = 5;
    const extraUsers = uniqueGroupUsers.length > displayLimit;
    const displayUsers = extraUsers ? uniqueGroupUsers.slice(0, displayLimit) : uniqueGroupUsers;

    const userDisplay = displayUsers.map((userId, index) => {
        const user = users.find(user => user.id === userId);
        let userName = user ? `${user.firstName} ${user.lastName}` : '';

        if (index < displayUsers.length - 1) {
            userName += ', ';
        }

        return (
            <React.Fragment key={userId}>
                <span className="ChatComponentHeader-userName">{userName}</span>
            </React.Fragment>
        );
    });


    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <div style={{display: "flex", paddingTop: 10}}>
            <div className="ChatComponentHeader-container">
                <Tooltip title={caseNumber}>
                    <div style={{cursor: "pointer"}}>
                        <MdGroup
                            onClick={(e) => {
                                e.stopPropagation();
                                handleEditChatGroup(groupId);
                            }}
                            className="ChatComponentHeader-mdGroupIcon"/>
                    </div>
                </Tooltip>
            </div>
            <div>
                <span className="ChatComponentHeader-caseNumber">{caseNumber}</span>
                <div className="ChatComponentHeader-userList">
                    {userDisplay}
                    {extraUsers && (
                        <Tooltip title={"ყველა მომხმარებლის ნახვა"}>
                            <div>
                                <IconButton size="small" className="ChatComponentHeader-icon" onClick={handleOpen}>
                                    <FaUserFriends/>+{uniqueGroupUsers.length - displayLimit}
                                </IconButton>
                            </div>
                        </Tooltip>
                    )}
                </div>
            </div>
            <Modal open={open} onClose={handleClose}>
                <Box className="ChatComponentHeader-modal">
                    <div className="ChatComponentHeader-modalHeader">
                        <h3>ყველა მომხმარებელი</h3>
                        <IconButton onClick={handleClose} className="ChatComponentHeader-closeButton">
                            <MdClose/>
                        </IconButton>
                    </div>
                    <ul>
                        {uniqueGroupUsers.map(userId => {
                            const user = users.find(user => user.id === userId);
                            return (
                                <li key={userId}>
                                    {user ? `${user.firstName} ${user.lastName}` : ''};
                                </li>
                            );
                        })}
                    </ul>
                </Box>

            </Modal>
        </div>
    );
};

export default ChatComponentHeader;
